import React, { useState, useContext, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { PeopleOutline } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import {
  Box,
  Grid,
  Alert,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
} from "@mui/material";
import Moment from "moment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import LoadUserProfile from "components/services/LoadUserProfile";
import ExcelClientListReport from "views/Print/ExcelClientListReport";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const infoStyle = {
  color: "#1d1d1b",
  fontSize: 10,
  fontWeight: "bold",
  margin: "3px 0",
  borderBottom: "1px solid #f2f2f2",
  paddingLeft: 2,
  padding: "2px 5px 2px 15px",
};

export default function ReportClientList(props) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    userData: null,
    statusData: null,
  });

  const [state] = useState({
    columns: [
      {
        headerName: "Gestor",
        field: "user.allNames",
        width: 200,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <div style={{ whiteSpace: "normal" }}>
              {renderProfile(params.row)}
            </div>
          );
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Cliente",
        field: "allNames",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Documento",
        field: "documentId",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Dependientes",
        field: "dependents",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 110,
        align: "center",
        renderCell: (params) => {
          return <b>{params.row.dependents.length} </b>;
        },
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        headerAlign: "center",
        width: 80,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text =
            params.value === 1
              ? "ACTIVO"
              : params.value === 99
              ? "PENDIENTE"
              : "INACTIVO";
          const color =
            params.value === 1
              ? "green"
              : params.value === 99
              ? "#000000"
              : "red";
          return (
            <>
              <b style={{ color: color, fontSize: 10 }}>{text}</b>
            </>
          );
        },
      },
    ],
  });

  const handleFromDateChange = (data) => {
    setFromDate(data);

    // Si la nueva fecha "Desde" es mayor que "Hasta", restablece "Hasta"
    if (data && toDate && data.isAfter(toDate)) {
      setToDate(null);
    } else {
      setToDate(null);
    }
  };

  const handleToDateChange = (data) => {
    setToDate(data);
  };

  const renderProfile = (row) => (
    <>
      <Typography sx={infoStyle} style={{ fontSize: 12 }}>
        {row.user.allNames}
      </Typography>
      <Typography sx={infoStyle} style={{ fontWeight: 500 }}>
        ({row.user.profile.name})
      </Typography>
    </>
  );

  const RefreshTable = async () => {
    setLoader(true);

    try {
      const response = await axios.get(`${urlServices}clients/list`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      });

      if (response.status === 200) {
        const transformedRows = response.data.map((data) => ({
          ...data,
          prefix: JSON.parse(data.prefix),
          dependents: parseJsonArray(data.dependents),
        }));

        let filteredRows = transformedRows;

        if (values.userData) {
          filteredRows = transformedRows.filter(
            (item) => item.userId === values.userData.id
          );
        }

        if (values.statusData) {
          filteredRows = transformedRows.filter(
            (item) => item.status === values.statusData.id
          );
        }

        if (fromDate && toDate) {
          // Convertir las fechas de fromDate y toDate a formato 'YYYY-MM-DD'
          const fromDateValue = dayjs(fromDate).format("YYYY-MM-DD");
          const toDateValue = dayjs(toDate).format("YYYY-MM-DD");

          // Filtrar los registros por el rango de fechas
          filteredRows = filteredRows.filter((item) => {
            const createdAt = dayjs(item.createdAt).format("YYYY-MM-DD");

            // Verifica si createdAt está dentro del rango entre fromDate y toDate
            return createdAt >= fromDateValue && createdAt <= toDateValue;
          });
        }

        setTotalRows(filteredRows.length);
        setRows(filteredRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const changeUserProfile = (data) => {
    setValues((prevValues) => ({
      ...prevValues,
      userData: data || null,
    }));

    setRows(data ? rows : []);
    setTotalRows(data ? totalRows : 0);
  };

  const changeStatus = (data) => {
    setValues((prevValues) => ({
      ...prevValues,
      statusData: data || null,
    }));
  };

  const handleSearch = () => () => {
    RefreshTable();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      aria-labelledby="customized-dialog-title"
      open={props.open}
      keepMounted
      scroll="body"
      PaperProps={{
        sx: {
          borderRadius: 6,
        },
      }}
    >
      <DialogContent dividers className={classes.styleDialogContent}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                {loader ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={loaderGif}
                          style={{ width: 60, margin: "20% 0" }}
                        />
                      </center>
                    </Grid>
                  </Grid>
                ) : (
                  <Fragment>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6}>
                        <div className={classes.cardTitleBlack}>
                          <PeopleOutline className={classes.iconFilter} />{" "}
                          Reporte de clientes
                        </div>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <Box style={{ float: "right" }}>
                          <span
                            className={classes.cardTitleBlack}
                            style={{ fontSize: 14, marginRight: 20 }}
                          >
                            Total registro{totalRows > 1 ? "s" : ""}:
                            {" " + totalRows}
                          </span>
                          <center>
                            <ExcelClientListReport
                              excelData={rows}
                              fileName={`Exportar_excel_clientes_lista`}
                              disabled={rows.length > 0 ? false : true}
                            />
                          </center>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <LoadUserProfile
                          value={values.userData}
                          refresh={changeUserProfile}
                          style={{ marginBottom: 2 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Autocomplete
                          id="combo-box-demo"
                          options={[
                            { id: 0, name: "Inactivo" },
                            { id: 1, name: "Activo" },
                          ]}
                          value={values.statusData}
                          onChange={(event, newValue) => changeStatus(newValue)}
                          getOptionLabel={(option) =>
                            option.name || "Seleccione ..."
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Filtro por estado"
                              variant="outlined"
                              margin="dense"
                              size="small"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "off", // disable autocomplete and autofill
                              }}
                              style={{ background: "#FFFFFF" }}
                            />
                          )}
                          classes={{
                            clearIndicatorDirty: "none",
                            popupIndicator: "none",
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="fromDate"
                              label="Desde"
                              value={fromDate}
                              onChange={(newValue) =>
                                handleFromDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="toDate"
                              label="Hasta"
                              value={toDate}
                              onChange={(newValue) =>
                                handleToDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                              disabled={fromDate ? false : true}
                              minDate={fromDate ? fromDate : null}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <center>
                          <ButtonStyle0
                            style={{ fontSize: 12, width: 130, marginTop: 10 }}
                            onClick={handleSearch()}
                          >
                            {values.userData ? "Aplicar filtro" : "Buscar todo"}
                          </ButtonStyle0>
                        </center>
                      </Grid>
                    </Grid>
                    <Grid container>
                      {rows.length > 0 ? (
                        <Grid item xs={12} sm={12}>
                          <Box
                            sx={{
                              "& .super-app.celAll": {
                                fontSize: 12,
                                //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                              },
                              "& .super-app.celActions": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              "& .super-app-theme--header": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              marginTop: 2,
                            }}
                            width="100%"
                          >
                            <DataGrid
                              rows={rows}
                              columns={state.columns}
                              loading={loader}
                              initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 100 },
                                },
                              }}
                              pageSizeOptions={[5, 10, 20, 100]}
                              disableRowSelectionOnClick={true}
                              checkboxSelection={false}
                              sx={{
                                [`& .${gridClasses.cell}`]: {
                                  display: "flex",
                                  alignItems: "center", // Alineación vertical
                                  // justifyContent: 'center', // Alineación horizontal
                                  wordWrap: "break-word !important",
                                  whiteSpace: "normal !important",
                                },
                                /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                              }}
                              //getRowHeight={() => "auto"}
                              // autoHeights
                              autoWidth
                            />
                          </Box>
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={12}>
                          <center>
                            <img
                              alt="loaderGif"
                              src={noDataImg}
                              style={{ width: 300, marginTop: 50 }}
                            />
                            <br></br>
                            <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                              No hay registros para mostrar
                            </b>
                          </center>
                        </Grid>
                      )}
                    </Grid>
                  </Fragment>
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <ButtonExit onClick={handleCloseDialog()}>Cerrar</ButtonExit>
      </DialogActions>
    </Dialog>
  );
}
